export default {
  ILS: '₪',
  USD: '$',
  BRL: 'R$',
  CHF: 'CHF',
  EUR: '€',
};
